import { Input, Toast } from '@seiue/ui'
import { isValidPhoneNumber, useCountDown } from '@seiue/util'
import { useAtom } from 'jotai'
import React from 'react'
import styled from 'styled-components'

import { authApi } from 'packages/sdks-next/growp'

import { reminderIdAtom } from './atom'

type IVerifyCodeProps = {
  value?: string
  onChange?: (value: string) => void
  readyPost?: boolean
  phoneNumber?: number
  style?: React.CSSProperties
  brandColor?: string
  validId?: number
  allowPostCode?: () => Promise<boolean>
  disabled?: boolean
  sendText?: string
}

/**
 * 验证码输入框
 *
 * @param param0 - 参数
 * @param param0.value - 验证码
 * @param param0.onChange - 验证码变化
 * @param param0.phoneNumber - 手机号
 * @param param0.brandColor - 品牌色
 * @param param0.validId - 一些特殊的校验 id，例如活动 ID
 * @param param0.allowPostCode - 是否允许发送验证码
 * @param param0.disabled - 是否禁用
 * @param param0.sendText - 发送验证码按钮文本
 * @returns 验证码输入框
 */
export const VerifyCode: React.FC<
  React.PropsWithChildren<IVerifyCodeProps>
> = ({
  value,
  onChange,
  phoneNumber,
  brandColor,
  validId,
  allowPostCode,
  disabled,
  sendText,
}) => {
  const [, setReminderId] = useAtom(reminderIdAtom)
  const { seconds, isCounting, startCounting } = useCountDown({
    seconds: 60,
  })

  const isDisabled = isCounting

  const generateCode = async () => {
    if (isDisabled) {
      return
    }

    if (!isValidPhoneNumber(String(phoneNumber || ''))) {
      Toast.warning('手机号不正确')

      return
    }

    const { data } = await authApi.reminders({
      identifier: String(phoneNumber),
      activityId: validId,
    })
    setReminderId(data.reminderId)
    Toast.success('发送成功')

    startCounting()
  }
  return (
    <Input
      size="middle"
      type="number"
      placeholder={"请输入验证码"}
      maxLength={4}
      defaultValue={value}
      onChange={(e) => {
        onChange?.(e.target.value)
      }}
      suffix={
        <GenerateCode
          disabled={isDisabled || !!disabled}
          onClick={async (e) => {
            e.stopPropagation()
            if (allowPostCode) {
              const allowPost = await allowPostCode?.()
              if (!allowPost) return
            }

            generateCode()
          }}
          style={{ color: brandColor }}
        >
          {isCounting ? `${seconds}s 后重新获取` : (sendText ?? '发送验证码')}
        </GenerateCode>
      }
    />
  )
}

const GenerateCode = styled.div.attrs((props: { disabled: boolean }) => ({
  disabled: props.disabled,
}))`
  font-size: 14px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  color: ${(props) =>
    props.disabled ? props.theme.text._3 : props.theme.brand._1};
`
